<template>
    <div class="absolute bottom-20 right-0 h-24 w-80" style="z-index: 9999999" v-if="!connected">
        <div class="animate-ping inset-0 absolute bg-gray-50 rounded-l-2xl border-2 border-gray-400 p-3 pt-5">
        </div>
        <div class="absolute inset-0 bg-gray-50 rounded-l-2xl border-2 border-gray-400 p-3 pt-5">
            <div class="w-full flex mb-2">
                <div class="relative w-8 h-5 ml-2">
                    <div class="absolute animate-[ping_600ms_linear_infinite]">
                        <span class="text-red-600 text-lg "><i class="fas fa-wifi"></i></span>
                    </div>
                    <div class="absolute">
                        <span class="text-red-600 text-lg "><i class="fas fa-wifi"></i></span>
                    </div>
                </div>
                <div class="text-red-600 text-md font-semibold">No connection to server!</div>
            </div>
            <div class="w-full ml-2">
                <span class="text-gray-500 text-sm">Attempting to reconnect...</span>
            </div>
        </div>
    </div>
    <div class="absolute bottom-20 right-0 h-24 w-80" style="z-index: 9999999" v-else-if="timeout < (60 * 5)">
        <div class="animate-ping inset-0 absolute bg-gray-50 rounded-l-2xl border-2 border-gray-400 p-3 pt-5">
        </div>
        <div class="absolute inset-0 bg-gray-50 rounded-l-2xl border-2 border-gray-400 p-3 pt-5">
            <div class="w-full flex mb-2">
                <div class="relative w-8 h-5 ml-2">
                    <div class="absolute animate-[ping_600ms_linear_infinite]">
                        <span class="text-red-600 text-lg "><i class="fas fa-exclamation-triangle"></i></span>
                    </div>
                    <div class="absolute">
                        <span class="text-red-600 text-lg "><i class="fas fa-exclamation-triangle"></i></span>
                    </div>
                </div>
                <div class="text-red-600 text-md font-semibold">Automatic Logout in {{ timeleft() }}</div>
            </div>
            <div class="w-full ml-2">
                <span class="text-gray-500 text-sm">You will be logged out due to inactivity</span>
            </div>
        </div>
    </div>

</template>

<script>
import User from "../../services/User";

export default {
    props: [],
    filters: {},
    data() {
        return {
            user: {connected:true},
            connected: true,
            timeout : 99999
        }
    },
    watch: {
        user: {
            handler(newValue, oldValue) {
                this.connected = newValue.connected;
                this.timeout = newValue.countdown;
            },
            deep: true,
        },
    },
    computed: {
    },
    methods: {
        timeleft(){
            if (this.timeout > 60) {
                let minutes = Math.ceil(this.timeout / 60);
                return minutes+' minutes'
            }
            return Math.max(0,this.timeout)+' seconds';
        }
    },
    async mounted() {
        await User.register();
        this.user = User;
    },
    beforeUpdate() {
        if ((!this.connected) || (this.timeout < (60 * 5))) {
            window.Bus.emit('connection-widget-show')
        } else {
            window.Bus.emit('connection-widget-hide')
        }
    }
}
</script>
